import ResizeHandler from "./resize-handler";
import Toggles from "./toggles";
import AdminbarHandler from "./adminbar-handler";
import Accordion from "./accordion";
import ScrollHandler from "./scroll-handler";

export default class MobileMenu {
    constructor(breakpoint, menuSelector, mobileHeaderHeight) {
        this.breakpoint = breakpoint;
        this.menuNode = document.querySelector(menuSelector);
        this.mobileHeaderHeight = mobileHeaderHeight;

        // necessary so that "this" references this instance in the callback
        this.setBodyOverflow = this.setBodyOverflow.bind(this);
        this.setMobileMenuHeight = this.setMobileMenuHeight.bind(this);
        this.openSubmenu = this.openSubmenu.bind(this);

        new AdminbarHandler(this.breakpoint);
        this.setResizeHandlers();
        this.setToggles();

        window.addEventListener('scroll', () => this.setMobileMenuHeight());
        window.addEventListener('resize', () => this.setMobileMenuHeight());
    }

    setResizeHandlers() {
        new ResizeHandler([
            // close mobile menu if open and window is resized to desktop width
            {
                width: this.breakpoint,
                selector: '.toggle.menu, .toggle.submenu',
                removeClass: '-active',
            },
            // close second level menu if open and window is resized to desktop width
            {
                width: this.breakpoint,
                selector: '.navigation.level-2.-open',
                removeClass: '-open',
                emitEvent: 'close-menu-accordion'
            },
            // remove fade-out transition of menu when window is resized from mobile to desktop width
            {
                width: this.breakpoint,
                selector: '.navigation.level-2',
                addClass: 'no-transition',
            },
            // remove fade-in transition of submenu when window is resized from desktop to mobile width
            {
                width: this.breakpoint,
                selector: '.navigation.level-2, .header-navigation',
                addClass: 'no-transition',
                evaluateInitial: false,
                direction: 'down'
            }
        ]);
    }

    setToggles() {
        new Toggles([
                {
                    selector: '.toggle',
                    triggers: 'click',
                    toggleClass: '-active'
                },
                {
                    selector: '.item.-has-children',
                    affectedChild: '.toggle.submenu',
                    triggers: ['mouseenter'],
                    addClass: '-active',
                    breakpoint: this.breakpoint
                },
                {
                    selector: '.item.-has-children',
                    affectedChild: '.toggle.submenu',
                    triggers: ['mouseleave'],
                    removeClass: '-active',
                    breakpoint: this.breakpoint
                },
                {
                    selector: '.item.-has-children',
                    affectedChild: '.navigation.level-2',
                    triggers: ['mouseenter'],
                    breakpoint: this.breakpoint,
                    addClass: 'fade-in',
                    removeClass: 'no-transition'
                },
                {
                    selector: '.item.-has-children',
                    affectedChild: '.navigation.level-2',
                    triggers: ['mouseleave'],
                    breakpoint: this.breakpoint,
                    removeClass: 'fade-in',
                },
                {
                    selector: '.toggle.menu',
                    affectedSibling: '.header-navigation',
                    triggers: 'click',
                    removeClass: 'no-transition',
                    callback: this.setMobileMenuHeight
                },
                {
                    selector: '.toggle.menu',
                    triggers: 'click',
                    callback: this.setBodyOverflow
                },
                {
                    selector: '.toggle.submenu',
                    affectedSibling: '.navigation.level-2',
                    triggers: 'click',
                    removeClass: 'no-transition',
                },
                // {
                //     selector: '.toggle.submenu',
                //     breakpoint: this.breakpoint,
                //     affectedSibling: '.navigation.level-2',
                //     triggers: 'click',
                //     toggleClass: 'fade-in'
                // },
                {
                    selector: '.link.-opens-submenu',
                    triggers: 'click',
                    preventDefault: true,
                    affectedSibling: '.navigation.level-2',
                    removeClass: 'no-transition'
                },
                {
                    selector: '.link.-opens-submenu',
                    triggers: 'click',
                    preventDefault: true,
                    affectedSibling: '.navigation.level-2',
                    toggleClass: 'fade-in',
                    breakpoint: this.breakpoint
                },
                {
                    selector: '.link.-opens-submenu',
                    triggers: 'click',
                    preventDefault: true,
                    affectedSibling: '.toggle.submenu',
                    toggleClass: '-active',
                    callback: this.openSubmenu
                },
                {
                  selector: '.link.-hoverable',
                  triggers: 'click',
                  preventDefault: true,
                  affectedSibling: '.toggle.submenu',
                  toggleClass: '-active',
                  callback: this.openSubmenu
                },
                {
                  selector: '.toggle.submenu',
                  triggers: 'click',
                  preventDefault: true,
                  affectedSibling: '.navigation.level-2',
                  toggleClass: 'fade-in',
                  callback: this.openSubmenu
                }
            ]
        );
    }

    openSubmenu(toggleNode, e) {
        if (window.innerWidth < this.breakpoint) {
            Accordion.transitionMaxHeight(toggleNode);
        }
    }

    setMobileMenuHeight() {
        let adminbar = document.querySelector('#wpadminbar');
        let adminbarHeight = 0;

        if (adminbar !== null) {
            let style = window.getComputedStyle(adminbar);
            if (style.display !== 'none') {
                adminbarHeight = 32;
            }
        }

        if (window.innerWidth < this.breakpoint) {
            this.menuNode.style.height = window.innerHeight - this.mobileHeaderHeight - adminbarHeight + 'px';
        } else {
            this.menuNode.style.height = '';
        }
    }

    setBodyOverflow(toggleNode) {
        if (window.innerWidth > this.breakpoint) {
            return;
        }

        if (toggleNode.classList.contains('-active')) {
            ScrollHandler.disableDocumentScroll(this.menuNode);
        } else {
            ScrollHandler.enableDocumentScroll();
        }
    }
}